import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Waypoint from 'react-waypoint';
import * as subscriptionActions from '../../actions/subscriptionActions';

const OPEN_TIMEOUT = 800;

class SubscribePromoWaypoint extends React.Component {
  constructor(props) {
    super(props);

    this.handleEnter = this.handleEnter.bind(this);
  }

  handleEnter() {
    const {isShown, subscriptionActions} = this.props;
    if (!isShown) {
      setTimeout(() => {subscriptionActions.showModal();}, OPEN_TIMEOUT);
    }
  }

  render () {
    const {handleEnter} = this;

    return (
      <Waypoint onEnter={handleEnter} />
    );
  }
}

SubscribePromoWaypoint.propTypes = {
  isShown: PropTypes.bool,
  subscriptionActions: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    isShown: state.subscription.isShown
  };
}

function mapDispatchToProps(dispatch) {
  return {
    subscriptionActions: bindActionCreators(subscriptionActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscribePromoWaypoint);



// WEBPACK FOOTER //
// ./src/components/SubscribePromo/SubscribePromoWaypoint.js